// lib
import moment from "moment";

export const daysInRange = (start, end) => {
  let current = start;
  const output = [];
  while (moment(current).isSameOrBefore(end)) {
    output.push(moment(current).format("YYYYMMDD"));
    current = moment(current).add(1, "d").toDate();
  }
  return output;
};
